import React, { useEffect } from 'react';
import { antdTheme } from '../config/theme.config';
import { notification, Spin, ConfigProvider } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
import { ErrorBoundary } from 'react-error-boundary';
import { LanguageContextProvider } from '../contexts/LanguageContext';
import { AuthContextProvider } from '../contexts/AuthContext';
import { ThemeContextProvider } from '../contexts/ThemeContext';
import { SocketContextProvider } from '../contexts/SocketContext';
import Router from '../routes/Router';
import '../assets/styles/SCSS/index.scss';
import { FallbackComponent } from './FallbackModal/FallbackComponent';
import { register } from '../serviceWorker';

Spin.setDefaultIndicator(<LoadingOutlined spin />);

const handleError = async (error) => {
  if (import.meta.env.MODE === 'production') {
    try {
      await fetch(`${import.meta.env.VITE_API_URL}/gitlab-issues`, {
        method: 'POST',
        body: JSON.stringify({
          error: { title: error?.message, description: error.toString() },
          path: window.location.href
        }),
        headers: new Headers({ 'Content-type': 'application/json' })
      });
    } catch (e) {
      notification.error({ message: "Impossible de signaler l'erreur" });
    }
  }
};

const App = () => {
  useEffect(() => {
    // Register service worker for PWA/update detection
    register({
      onUpdate: (registration) => {
        console.log('Service worker update available', registration);
      },
      onWaiting: (waiting) => {
        console.log('Service worker waiting', waiting);
      }
    });
  }, []);

  return (
    <ErrorBoundary FallbackComponent={FallbackComponent} onError={handleError}>
      <ConfigProvider theme={antdTheme}>
        <LanguageContextProvider>
          <AuthContextProvider>
            <ThemeContextProvider>
              <SocketContextProvider>
                <Router />
              </SocketContextProvider>
            </ThemeContextProvider>
          </AuthContextProvider>
        </LanguageContextProvider>
      </ConfigProvider>
    </ErrorBoundary>
  );
};

export default App;
